<template>
  <div class="modal-overlay" @click.self="closePhoneModal()">
    <div class="modal-window">
      <div class="modal-content">
        <p class="modal-subtitle">
          Оставьте номер телефона — мы свяжемся с вами в ближайшее время
        </p>

        <form @submit.prevent="submitPhone" class="phone-form">
          <!-- Телефон с маской -->
          <PhoneInput
            v-model="phone"
            placeholder="+7 900 000-00-00"
            :disabled="isLoading"
          />
          <!-- Имя -->
          <input
            type="text"
            v-model="name"
            placeholder="Ваше имя"
            class="modal-input"
            required
            autocomplete="name"
          />
          <!-- Кнопка отправки -->
          <button
            type="submit"
            class="submit-button button-1"
            :disabled="isLoading || !isFormValid"
          >
            {{ isLoading ? "Отправка..." : "Отправить" }}
          </button>
        </form>

        <div v-if="successMessage" class="success-message">
          {{ successMessage }}
        </div>

        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
      </div>

      <button class="modal-close" @click="closePhoneModal()">✖</button>
    </div>
  </div>
</template>

<script>
import PhoneInput from "@/components/modals/PhoneInput.vue";
import { useModalStore } from "@/stores/modals";

export default {
  name: "CallbackPhoneModal",

  components: {
    PhoneInput,
  },

  setup() {
    const modalStore = useModalStore();
    return { modalStore };
  },

  data() {
    return {
      name: "",
      phone: "", // PhoneInput сам поставит +7 при необходимости
      successMessage: "",
      errorMessage: "",
      isLoading: false,
    };
  },

  computed: {
    isFormValid() {
      return (
        this.name.trim().length > 0 &&
        this.phone.startsWith("+7") &&
        this.phone.length === 12
      );
    },
  },

  methods: {
    closePhoneModal() {
      this.modalStore.closePhoneModal();
    },

    async submitPhone() {
      this.errorMessage = "";
      this.successMessage = "";

      if (!this.isFormValid) {
        this.errorMessage = "Пожалуйста, заполните все поля корректно";
        return;
      }

      this.isLoading = true;

      try {
        const response = await fetch(
          "https://dancerus.ru/api/submit_phone.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              name: this.name.trim(),
              phone: this.phone,
            }),
          }
        );

        const data = await response.json();

        if (data.status === "success") {
          this.successMessage =
            data.message || "Спасибо! Мы свяжемся с вами скоро.";
          this.name = "";
          this.phone = "";

          setTimeout(() => {
            this.$emit("close");
            this.closePhoneModal();
          }, 3000);
        } else {
          this.errorMessage = data.message || "Ошибка отправки";
        }
      } catch (e) {
        this.errorMessage = "Ошибка сети. Попробуйте позже.";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/mixins.scss";
.phone-form {
  margin: 0 auto;
  max-width: 360px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
}

.submit-button,
.button-1 {
  max-width: 240px;
  align-self: center;
}
</style>
